<!-- @format -->

<accept-error-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h3 class="modal_heading margin-spacing-3_bottom">
          エラーが発生しました
        </h3>
        <p class="note">{props.message}</p>
        <div class="wrap_button margin-spacing-4_top">
          <template if="{ props.errorType!='bank_account' }">
            <div
              class="
                button button-secondary-large button-border
                margin-spacing-1_right
              "
              type="button"
              onclick="{ props.onClose }"
            >
              閉じる
            </div>
          </template>
          <template if="{ props.errorType=='bank_account' }">
            <a
              href="{ routes.makePath('info-bank-account-tag') }"
              class="button button-secondary-large margin-spacing-1_right"
              type="button"
              onclick="{ props.onClose }"
            >
              銀行口座を登録する
            </a>
          </template>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->
  <script>
    import di from "dependeny-injection";
    import base from "../modal-base.riot";
    import routes from "@model/menu-routes.js";

    export default {
      components: {
        "modal-base": base,
      },
      onBeforeMount() {
        this.routes = routes;
      },
    };
  </script>
</accept-error-modal>
